// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Ujh1s","container":"styles_container__2qe9C","title":"styles_title__1kL3F","wrapper":"styles_wrapper__3yBkT","answer":"styles_answer__1VlSt"};